/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import Content from "@/core/layout/Content.vue"
import DashboardLayout, {
    registrarModuloMenu,
} from "@/core/layout/DashboardLayout.vue"
import Login from "@/core/pages/Login.vue"
import NotFound from "@/core/pages/NotFoundPage.vue"
import Vue from "vue"
import VueRouter from "vue-router"

import AdministradorRoutes from "@/modules/administrador/routes"
import AlmoxarifadoRoutes from "@/modules/almoxarifados/routes"
import AtaRegistroPrecoRoutes from "@/modules/ata-registro-preco/routes"
import CadastroRoutes from "@/modules/cadastros/routes"
import ContratosRoutes from "@/modules/contratos/routes"
import GerenciamentoRoutes from "@/modules/gerenciamento/routes"
import FinanceiroRoutes from "@/modules/gestao-financeira/routes"
import PatrimonioRoutes from "@/modules/patrimonio/routes"
import ComprasRoutes from "@/modules/compra/routes"


Vue.use(VueRouter);

registrarModuloMenu(
    CadastroRoutes,
    AlmoxarifadoRoutes,
    GerenciamentoRoutes,
    PatrimonioRoutes,
    AdministradorRoutes,
    ContratosRoutes,
    FinanceiroRoutes,
    AtaRegistroPrecoRoutes,
    ComprasRoutes
);
import {
  getDataExpiracao,
} from "@/core/auth";
const routes = [
    {
        path: "/",
        component: Login,
        name: "Inicial",
        meta: { public: true }
    },
    {
        path: "/dashboard",
        component: DashboardLayout,
        name: "Dashboard",
        meta: { requiresAuth: true },
        children: [
            {
                path: "",
                name: "DashboardPage",
                component: () => import("@/pages/Dashboard.vue"),
                meta: { requiresAuth: true }
            },
            CadastroRoutes,
            AlmoxarifadoRoutes,
            GerenciamentoRoutes,
            PatrimonioRoutes,
            AdministradorRoutes,
            ContratosRoutes,
            FinanceiroRoutes,
            AtaRegistroPrecoRoutes,
            ComprasRoutes
        ],
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: { public: true }
    },
    {
        path: "/error",
        name: "Unauthorized",
        component: NotFound,
        meta: { public: true }
    },
    {
        path: "*",
        component: NotFound,
        meta: { public: true }
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

function isTokenExpirado(token) {
    try {
        return new Date(token) < new Date();
    } catch (e) {
        return true;
    }
}

router.beforeEach((to, from, next) => {
    const dataExpiracao = getDataExpiracao();


    const rotaPublica = to.matched.some(r => r.meta.public);
    const exigeAuth = to.matched.some(r => r.meta.requiresAuth);

    if (!rotaPublica && exigeAuth && (!dataExpiracao || isTokenExpirado(dataExpiracao))) {

        return next({
            path: "/login",
            query: { redirect: to.fullPath }
        });
    }

    next();
});




export default router;
